var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencilAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/pencil-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.16732 4.16667H5.00065C4.08018 4.16667 3.33398 4.91286 3.33398 5.83334V15C3.33398 15.9205 4.08018 16.6667 5.00065 16.6667H14.1673C15.0878 16.6667 15.834 15.9205 15.834 15V10.8333M14.6555 2.98816C15.3063 2.33728 16.3616 2.33728 17.0125 2.98816C17.6634 3.63903 17.6634 4.6943 17.0125 5.34518L9.85767 12.5H7.50065L7.50065 10.143L14.6555 2.98816Z",
    stroke: "#FFB447",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilAlt);
export default __webpack_public_path__ + "static/media/icon-pencil-alt.107e2ce288581f6b36aec8935e010032.svg";
export { ForwardRef as ReactComponent };